import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { DecodeData } from '../components/shared/Aes';
import { useEffect } from 'react';


function EventImagePage(props) {
    const [searchParams, setSearchParams] = useSearchParams();  
    const [srcUrl, setSrcUrl] = useState("");



    useEffect(() => {
        const encryptedUrl = searchParams.get("srcUrl");
      
        
        if (encryptedUrl) {
            const urlDecoded = decodeURIComponent(encryptedUrl);
            const fixedEncrypted = encryptedUrl.replace(/ /g, '+');
            const decodedSrcUrl = DecodeData(fixedEncrypted);
            
            setSrcUrl(decodedSrcUrl);
        }
    }, [searchParams]);
 

    return (
        <div>
            <img src={srcUrl} />
        </div>
    );
}

export default EventImagePage;